// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddInsufficiencyVendor {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7019607843);
  backdrop-filter: blur(3px);
  z-index: 1;
  overflow: auto;
}
.AddInsufficiencyVendor .AddDetails {
  min-width: 60%;
  max-width: 70%;
  max-height: 90%;
  padding: 1.25rem;
  border-radius: 0.5rem;
  background: var(--Foreground);
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  overflow: auto;
}
.AddInsufficiencyVendor .AddDetails p {
  color: var(--TextColor);
}
.AddInsufficiencyVendor .AddDetails header {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  margin-bottom: 1rem;
}
.AddInsufficiencyVendor .AddDetails header h1 {
  flex: 1 1;
  color: var(--AccentColor);
  font-size: 1.5rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.AddInsufficiencyVendor .AddDetails header button {
  width: 3.75rem;
  height: 1.5rem;
  border-radius: 0.25rem;
  color: #ffffff;
  font-size: 0.75rem;
  background: var(--AccentColor);
}
.AddInsufficiencyVendor .AddDetails header .Close {
  background: #cccad4;
  color: #212121;
}
.AddInsufficiencyVendor .AddDetails section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  overflow: auto;
}
.AddInsufficiencyVendor .AddDetails section .Title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--TextColor);
}
.AddInsufficiencyVendor .AddDetails section .InputContainer {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(15.625rem, 1fr));
  gap: 1.25rem;
}
.AddInsufficiencyVendor .AddDetails section .InputContainer input,
.AddInsufficiencyVendor .AddDetails section .InputContainer select {
  border: none;
  background: var(--Invitation);
  border-bottom: 0.125rem solid var(--Stroke);
  height: 2rem;
  padding: 0 0.5rem;
  color: var(--TextColor);
}
.AddInsufficiencyVendor .AddDetails section .InputContainer input option,
.AddInsufficiencyVendor .AddDetails section .InputContainer select option {
  color: var(--TextColor);
  background: var(--Foreground);
}
.AddInsufficiencyVendor .AddDetails section .InputContainer input:disabled, .AddInsufficiencyVendor .AddDetails section .InputContainer select:disabled {
  opacity: 0.5;
}
.AddInsufficiencyVendor .AddDetails section .InputContainer .LabelInputCont {
  display: flex;
  flex-direction: column;
}
.AddInsufficiencyVendor .AddDetails section .InputContainer .LabelInputCont span {
  font-size: 0.75rem;
  color: var(--AccentColor);
}
.AddInsufficiencyVendor .AddDetails section .InputContainer .LabelInputCont .MonthYear {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.AddInsufficiencyVendor .AddDetails section .InputContainer .LabelInputCont .MonthYear .Month {
  flex: 1 1;
}
.AddInsufficiencyVendor .AddDetails section .InputContainer .LabelInputCont .MonthYear .Year {
  width: 6.875rem;
}
.AddInsufficiencyVendor .AddDetails section h5 {
  color: var(--TextColor);
  font-weight: 700;
  font-size: 0.875rem;
}
.AddInsufficiencyVendor .AddDetails section .FileInput {
  display: flex;
  padding-top: 1.25rem;
}
.AddInsufficiencyVendor .AddDetails section .FileInput input {
  display: none;
}
.AddInsufficiencyVendor .AddDetails section .FileInput .FileInputLabel {
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0.75rem;
  background: var(--AccentColor);
  color: #ffffff;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 0.875rem;
}
.AddInsufficiencyVendor .AddDetails section .FileList {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border-radius: 1.25rem;
}
.AddInsufficiencyVendor .AddDetails section .FileList .Document {
  margin: 0.625rem;
  background: var(--AccentColor);
  border-radius: 0.625rem;
  display: flex;
  align-items: center;
  position: relative;
  transition: all 0.3s ease;
}
.AddInsufficiencyVendor .AddDetails section .FileList .Document .DocumentName {
  padding: 0.625rem 2.5rem 0.625rem 0.625rem;
  display: inherit;
  flex-direction: inherit;
  align-items: inherit;
  gap: 0.5rem;
  background: var(--Invitation);
  border-radius: 0.5rem;
  z-index: 1;
  transition: all 0.3s ease;
}
.AddInsufficiencyVendor .AddDetails section .FileList .Document .DocumentName span {
  font-size: 0.875rem;
  font-weight: 400;
  white-space: nowrap;
  max-width: 18.75rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.AddInsufficiencyVendor .AddDetails section .FileList .Document .Delete {
  position: absolute;
  top: 50%;
  right: 0.625rem;
  transform: translateY(-50%);
  cursor: pointer;
  min-width: 1.25rem;
  min-height: 1.25rem;
  opacity: 0;
}
.AddInsufficiencyVendor .AddDetails section .FileList .Document .Delete path {
  fill: #ffffff;
}
.AddInsufficiencyVendor .AddDetails section .FileList .Document:hover {
  padding-right: 2.5rem;
  transition: all 0.3s ease;
}
.AddInsufficiencyVendor .AddDetails section .FileList .Document:hover .DocumentName {
  padding: 0.625rem;
  transition: all 0.3s ease;
}
.AddInsufficiencyVendor .AddDetails section .FileList .Document:hover .Delete {
  opacity: 1;
  transition: all 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/Components/Insufficiency/AddInsufficiencyVendor.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,0BAAA;EACA,UAAA;EACA,cAAA;AACJ;AAAI;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AAEN;AADM;EACE,uBAAA;AAGR;AADM;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AAGR;AAFQ;EACE,SAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAIV;AAFQ;EACE,cAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,8BAAA;AAIV;AAFQ;EACE,mBAAA;EACA,cAAA;AAIV;AADM;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AAGR;AAFQ;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AAIV;AAFQ;EACE,aAAA;EACA,gEAAA;EACA,YAAA;AAIV;AAHU;;EAEE,YAAA;EACA,6BAAA;EACA,2CAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAKZ;AAJY;;EACE,uBAAA;EACA,6BAAA;AAOd;AAJU;EACE,YAAA;AAMZ;AAJU;EACE,aAAA;EACA,sBAAA;AAMZ;AALY;EACE,kBAAA;EACA,yBAAA;AAOd;AALY;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAOd;AANc;EACE,SAAA;AAQhB;AANc;EACE,eAAA;AAQhB;AAHQ;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AAKV;AAHQ;EACE,aAAA;EACA,oBAAA;AAKV;AAJU;EACE,aAAA;AAMZ;AAJU;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,8BAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;AAMZ;AAHQ;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AAKV;AAJU;EACE,gBAAA;EACA,8BAAA;EAEA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAKZ;AAJY;EACE,0CAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,WAAA;EACA,6BAAA;EACA,qBAAA;EACA,UAAA;EACA,yBAAA;AAMd;AALc;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAOhB;AAJY;EACE,kBAAA;EACA,QAAA;EACA,eAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AAMd;AALc;EACE,aAAA;AAOhB;AAHU;EACE,qBAAA;EACA,yBAAA;AAKZ;AAJY;EACE,iBAAA;EACA,yBAAA;AAMd;AAJY;EACE,UAAA;EACA,yBAAA;AAMd","sourcesContent":[".AddInsufficiencyVendor {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #000000b3;\n    backdrop-filter: blur(3px);\n    z-index: 1;\n    overflow: auto;\n    .AddDetails {\n      min-width: 60%;\n      max-width: 70%;\n      max-height: 90%;\n      padding: 1.25rem;\n      border-radius: 0.5rem;\n      background: var(--Foreground);\n      display: flex;\n      flex-direction: column;\n      gap: 1.25rem;\n      overflow: auto;\n      p{\n        color: var(--TextColor);\n      }\n      header {\n        display: flex;\n        align-items: center;\n        gap: 1.25rem;\n        margin-bottom: 1rem;\n        h1 {\n          flex: 1;\n          color: var(--AccentColor);\n          font-size: 1.5rem;\n          font-weight: 700;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n        button {\n          width: 3.75rem;\n          height: 1.5rem;\n          border-radius: 0.25rem;\n          color: #ffffff;\n          font-size: 0.75rem;\n          background: var(--AccentColor);\n        }\n        .Close {\n          background: #cccad4;\n          color: #212121;\n        }\n      }\n      section {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        gap: 1.25rem;\n        overflow: auto;\n        .Title {\n          font-size: 1rem;\n          font-weight: 700;\n          color: var(--TextColor);\n        }\n        .InputContainer {\n          display: grid;\n          grid-template-columns: repeat(auto-fill, minmax(15.625rem, 1fr));\n          gap: 1.25rem;\n          input,\n          select {\n            border: none;\n            background: var(--Invitation);\n            border-bottom: 0.125rem solid var(--Stroke);\n            height: 2rem;\n            padding: 0 0.5rem;\n            color: var(--TextColor);\n            option{\n              color: var(--TextColor);\n              background: var(--Foreground);\n            }\n          }\n          input:disabled, select:disabled{\n            opacity: 0.5;\n          }\n          .LabelInputCont {\n            display: flex;\n            flex-direction: column;\n            span {\n              font-size: 0.75rem;\n              color: var(--AccentColor);\n            }\n            .MonthYear {\n              display: flex;\n              align-items: center;\n              gap: 0.75rem;\n              .Month {\n                flex: 1;\n              }\n              .Year {\n                width: 6.875rem;\n              }\n            }\n          }\n        }\n        h5 {\n          color: var(--TextColor);\n          font-weight: 700;\n          font-size: 0.875rem;\n        }\n        .FileInput {\n          display: flex;\n          padding-top: 1.25rem;\n          input {\n            display: none;\n          }\n          .FileInputLabel {\n            width: auto;\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            gap: 0.75rem;\n            padding: 0.5rem 0.75rem;\n            background: var(--AccentColor);\n            color: #ffffff;\n            border-radius: 0.25rem;\n            cursor: pointer;\n            font-size: 0.875rem;\n          }\n        }\n        .FileList {\n          width: 100%;\n          display: flex;\n          flex-direction: row;\n          flex-wrap: wrap;\n          border-radius: 1.25rem;\n          .Document {\n            margin: 0.625rem;\n            background: var(--AccentColor);\n            // padding-right: 2.5rem;\n            border-radius: 0.625rem;\n            display: flex;\n            align-items: center;\n            position: relative;\n            transition: all 0.3s ease;\n            .DocumentName {\n              padding: 0.625rem 2.5rem 0.625rem 0.625rem;\n              display: inherit;\n              flex-direction: inherit;\n              align-items: inherit;\n              gap: 0.5rem;\n              background: var(--Invitation);\n              border-radius: 0.5rem;\n              z-index: 1;\n              transition: all 0.3s ease;\n              span {\n                font-size: 0.875rem;\n                font-weight: 400;\n                white-space: nowrap;\n                max-width: 18.75rem;\n                overflow: hidden;\n                text-overflow: ellipsis;\n              }\n            }\n            .Delete {\n              position: absolute;\n              top: 50%;\n              right: 0.625rem;\n              transform: translateY(-50%);\n              cursor: pointer;\n              min-width: 1.25rem;\n              min-height: 1.25rem;\n              opacity: 0;\n              path{\n                fill: #ffffff;\n              }\n            }\n          }\n          .Document:hover {\n            padding-right: 2.5rem;\n            transition: all 0.3s ease;\n            .DocumentName {\n              padding: 0.625rem;\n              transition: all 0.3s ease;\n            }\n            .Delete{\n              opacity: 1;\n              transition: all 0.3s ease;\n            }\n          }\n        }\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
